import React from 'react';
import { Input } from 'web-ui-components/lib/atoms/forms';
import { Field as FormField, FieldBody, FieldHeader } from 'web-ui-components/lib/molecules/forms';
import { BlockFieldColumn } from 'web-ui-components/lib/global/layout';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import PropTypes from 'prop-types';
import { isRequiredAddress, isRequiredAddressOptional } from '../addressUtils/addressUtils';
let validationFlag = false;

const houseName = document.getElementsByName('ukAddress.local.HouseName');
const buildNumber = document.getElementsByName('ukAddress.local.BuildingNumber');

const validateHouseAndBuilding = v => {
  if (buildNumber.length > 0 || houseName.length > 0) {
    validationFlag = true;
  }
  if (
    buildNumber.length > 0 &&
    !buildNumber[0].value &&
    houseName.length > 0 &&
    !houseName[0].value
  ) {
    validationFlag = false;
  }
  if (validationFlag) {
    return isRequiredAddressOptional(v, 'alphanumeric');
  }
  return isRequiredAddress(v, 'alphanumeric');
};
const validator = (name, optionalField, v) => {
  if (name === 'BuildingNumber' || name === 'HouseName') {
    return validateHouseAndBuilding(v);
  }
  return optionalField
    ? isRequiredAddressOptional(v, 'alphanumeric')
    : isRequiredAddress(v, 'alphanumeric');
};

const TextQuestionComponent = ({
  type,
  name,
  label,
  labelError,
  columnWidth,
  maxAddressLength,
  optionalField
}) => (
  <Content>
    {content => (
      <Field name={`${type}.${name}`} subscription={{ touched: true, error: true }}>
        {({ meta: { touched, error } }) => (
          <FormField>
            <FieldHeader
              name={`${type}.${name}`}
              hasError={touched && !!error}
              title={content[label]}
              validationMessage={content[labelError]}
            />
            <FieldBody hasError={touched && !!error}>
              <Field
                name={`${type}.${name}`}
                component="input"
                validate={v => validator(name, optionalField, v)}
              >
                {({ input }) => (
                  <BlockFieldColumn column={columnWidth}>
                    <Input
                      name={`${type}.${name}`}
                      type="text"
                      maxLength={maxAddressLength}
                      {...input}
                    />
                  </BlockFieldColumn>
                )}
              </Field>
            </FieldBody>
          </FormField>
        )}
      </Field>
    )}
  </Content>
);

TextQuestionComponent.propTypes = {
  columnWidth: PropTypes.number,
  type: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  labelError: PropTypes.string.isRequired,
  maxAddressLength: PropTypes.number
};
TextQuestionComponent.defaultProps = {
  columnWidth: 6,
  maxAddressLength: 40
};

export default TextQuestionComponent;
